import React, { FC } from 'react';

import Styled from './style';
import { AuthWrapper } from '../../shared/auth-wrapper';
import { Indicator } from './components/indicator';
import { Typography } from '../../shared/typography';

type IProps = {};

const WelcomePage: FC<IProps> = () => {
	return (
		<AuthWrapper>
			<Styled.Bottom>
				<Styled.WrapTitle>
					<Styled.Title text={'Welcome!'} style={{ textAlign: 'center' }} />
				</Styled.WrapTitle>
				<Styled.Content>
					<Styled.Center>
						<Indicator percentVisible callback={() => null} />
						<Typography
							size="large"
							style={{ textAlign: 'center', marginTop: 50 }}
						>
							We are fetching your data, and will be done in 15 minutes. Don't
							worry, we'll let you know once it's completed
						</Typography>
					</Styled.Center>
				</Styled.Content>
			</Styled.Bottom>
		</AuthWrapper>
	);
};

export default WelcomePage;
